export { A11yPageTitle, default } from './Page';
